import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import BitemporalViewer from '../BitemporalViewer/BitemporalViewer';
import {
  getCreditHistory,
  getCreditAtTime,
} from '../../services/bitemporalApi';
import type { Credit as BitemporalCredit } from '../../services/api';

export default function BitemporalTest() {
  const [viewerOpen, setViewerOpen] = useState(false);
  
  const renderCreditData = (credit: BitemporalCredit) => (
    <Box>
      <Typography variant="body1"><strong>Name:</strong> {credit.name}</Typography>
      <Typography variant="body1"><strong>Description:</strong> {credit.description || 'N/A'}</Typography>
      <Typography variant="body1">
        <strong>Valid For:</strong> {credit.valid_for_days ? `${credit.valid_for_days} days` : 'No limit'}
      </Typography>
    </Box>
  );

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Bitemporal Functionality Test
      </Typography>
      
      <Button 
        variant="contained" 
        onClick={() => setViewerOpen(true)}
        sx={{ mb: 2 }}
      >
        Open Bitemporal Viewer (Test Credit 1)
      </Button>
      
      <Typography variant="body1" color="text.secondary">
        This test component demonstrates the bitemporal viewer functionality.
        Click the button above to open the viewer for a test credit.
      </Typography>

      <BitemporalViewer
        entityId="test_credit_1"
        entityType="Credit"
        onGetHistory={getCreditHistory}
        onGetAtTime={getCreditAtTime}
        renderData={renderCreditData}
        open={viewerOpen}
        onClose={() => setViewerOpen(false)}
      />
    </Box>
  );
}